import { ModelProgress } from '~/features/x-ray/types/model';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { PromptModelProgress } from '../../types/sylvanus/model';

interface Request {
  modelId: Uuid;
}

type Response = ModelProgress;

export const getPromptModelProgress = async ({
  modelId,
}: Request): Promise<Response> => {
  const response: PromptModelProgress = await sylvanus.get(
    `/model/${modelId}/progress`,
  );

  const docsFailed = response.docs_failed ?? 0;
  const docsInScope = response.docs_in_scope;
  const docsInScopeProcessing = response.dirty ?? false;
  const docsProcessed = response.docs_processed ?? 0;
  const optimizeState = response.current_optimize_state ?? null;
  const publishStatus = response.current_publish_status ?? null;
  const valuesFound = response.values_found ?? 0;

  return {
    docsFailed,
    docsInScope,
    docsProcessed,
    optimizeState,
    publishStatus,
    valuesFound,
    docsInScopeProcessing,
  };
};
